export enum OrderSynchronizationStatus
{
    Unknown = 0,
    Pending = 10,
    Approved = 20,
    PartiallyApproved = 21,
    Sent = 30,
    PartiallySent = 31
}